import * as api from "./assets/js/asyn";
let base = "";
// if (appUseObj == 'ODERP') {
//     base = '/od'
// } else {
//     base = '/mcn'
// }

//------------------------------User Auth-----------------------
//默认文件上传
export const upload_default_path = `${base}/file/upload`;
//图片上传
export const upload_picture_path = `${base}/upload/picture`;
//今日上传的图片
export const getFileUploadList = params => {
    return api.get(`${base}/file/upload`, params);
}
export const login = params => {
    return api.post(`${base}/user/logon`, params);
};
export const loginDev = params => {
    return api.post(`/api/developer/logon`, params);
};
export const refresh = params => {
    return api.post(`${base}/user/refresh`, params);
};
//user info
export const getUserInfo = params => {
    return api.get(`${base}/user/info`, params);
};
//验证token是否可用
export const getToKen = params => {
    return api.get(`${base}/user/test`, params);
};
//user logout
export const postLogout = params => {
    return api.post(`/api/user/logout`, params);
};
//公告阅读
export const putSystemNoticeReadId = params => {
    return api.put(`${base}/system/notice/read/id/${params.id}`, params)
}
//修改自己的密码
export const updateOwnPassword = params => {
    return api.put(`api/user/pwd`, params);
};
// 备忘录-新建
export const postSystemMemo = params => {
    return api.post(`${base}/system/memo`, params)
};
//备忘录-列表
export const getSystemMemo = params => {
    return api.get(`${base}/system/memo`, params)
};
//备忘录-修改
export const putSystemMemoId = params => {
    return api.put(`${base}/system/memo/id/${params.id}`, params)
};
//备忘录-删除
export const deleteSystemMemoId = params => {
    return api.del(`${base}/system/memo/id/${params.id}`)
};
//警报信息列表
export const getHomeWarnList = params => {
    return api.get(`${base}/home/warn/all`, params)
};
//警报信息确认
export const postHomeWarnConfirmId = params => {
    return api.post(`${base}/home/warn/confirm/id/${params.id}`)
};
//公告静态属性
export const getPublicStaticAll = params => {
    return api.get(`/api/static/all`, params);
};
//OA静态属性
export const getOaStaticAll = params => {
    return api.get(`/api/static/all`, params);
};
//登录验证码
export const getCodeImg = () => {
    return api.get(`${base}/user/login/captcha`)
};
//首页汇率趋势
export const getExchangeRateTrend = params => {
    return api.get(`${base}/finance/currency/trend`, params);
};
//OA首页接口
export const homeList = params => {
    return api.get(`${base}/home/index`, params);
};
export const getWorkFlowRemindNum = params => {
    return api.get(`${base}/home/work/flow/remind/num`, params);
};
export const homeNoticeList = params => {
    return api.get(`${base}/home/notice`, params);
};
//警报信息详细
export const getHomeWarnId = params => {
    return api.get(`${base}/home/warn/id/${params.id}`)
};
//获取跳转链接
export const getUserGotoUrl = params => {
    return api.get(`${base}/user/goto/url`, params);
}
//安全码-更新
export const postUserSecurityCodeUpdata = params => {
    return api.put(`${base}/user/securityCode`, params);
}
//企业微信登录接口
export const postWechatLogin = params => {
    return api.post(`${base}/user/qywechat/logon`, params);
};

//SKU列表
export const getProductSku = params => {
    return api.get(`${base}/product/sku`, params);
};

// 亚马逊Listing批量更新关联
export const postAmazonListingUpdateBind = params => {
    return api.post(`${base}/sale/amazon/listing/update/bind`, params);
};

/**获取产品-列表 */
export const getProductList = (params) => {
    return api.get('/api/tiktok/product', params)
}

/**关联sku */
export const postBindSku = (params) => {
    return api.post('api/tiktok/update/sku/bind', params)
}

/**批量关联sku */
export const postBatchBindSku = (params) => {
    return api.post('api/tiktok/update/sku/bind/batch', params)
}

/**绑定亚马逊渠道Sku */
export const postBindAmazonSku = (params) => {
    return api.post("api/tiktok/update/fnsku/bind", params)
}

/**产品归档还原 */
export const postProductFileRestore = (params) => {
    return api.post("api/tiktok/file/batch", params)
}

/**绑定负责人 */
export const postBindPrincipal = (params) => {
    return api.post("api/tiktok/principal", params)
}

/**获取店铺-列表 */
export const getShopList = (params) => {
    return api.get('api/tiktok/store', params)
}

/**新增-店铺 */
export const postCreateShop = (params) => {
    return api.post('api/tiktok/store', params)
}

/**编辑-店铺 */
export const putEditeShop = (params) => {
    return api.put(`api/tiktok/store/id/${params.id}`, params)
}

/**获取产品-日志 */
export const getProductLog = (params) => {
    return api.get(`api/tiktok/product/log`, params)
}

/**获取商品 */
export const postProductPull = (params) => {
    return api.post("api/tiktok/product/pull", params)
}
/**订单列表 */
export const getOrderList = (params) => {
    return api.get('api/tiktok/order', params)
}
/**订单详情 */
export const getOrderDetail = (params) => {
    return api.get('api/tiktok/order/detail', params)
}
/**订单商品列表 */
export const getOrderGoodsList = (params) => {
    return api.get('/api/tiktok/order/item', params)
}
/**订单操作日志 */
export const getOrderLog = (params) => {
    return api.get('api/tiktok/order/log', params)
}
/**拉取订单 */
export const postPullOrder = (params) => {
    return api.post('api/tiktok/order/pull', params)
}

/**刷新订单-关联 */
export const postRefreshRelevance = (params) => {
    return api.post('api/tiktok/refresh/bind', params)
}

/**批量同步物流 */
export const postBatchSyncLogistics = (params) => {
    return api.post('/api/tiktok/order/push/shipped', params)
}

/**获取fba库存 */
export const postGetFbaInventory = (params) => {
    return api.post('api/tiktok/order/fba/inventory', params)
}

/**创建出库单 */
export const postCreateOutboundDeliveryOrder = (params) => {
    return api.post('api/tiktok/order/out', params)
}

/**获取授权链接 */
export const getGetAuthUrl = (params) => {
    return api.get(`api/tiktok/store/auth/url`, params)
}

// 选择产品列表
export const getSaleFbaStockSelect = params => {
    return api.post(`${base}/sale/fba/stock/select`, params)
};

/**绑定亚马逊渠道sku */
export const postBindFnsku = (params) => {
    return api.post('api/tiktok/order/fnsku/bind',params)
}
/**获取退货列表 */
export const getReturnsOrderList = (params) => {
    return api.get('api/tiktok/return/order',params)
}
/**获取退货详情 */
export const getReturnsDetail = (params) => {
    return api.get('api/tiktok/return/order/item',params)
}

/**获取账单列表 */
export const getStatementList = (params) => {
    return api.get('/api/tiktok/statement',params)
}
/**获取账单详情 */
export const getStatementDetail = (params) => {
    return api.get('api/tiktok/statement/transactions',params)
}

// 订单利润报表
export const orderProfitStatementList = (params) => {
    return api.get(`/api/tiktok/finance/profits`, params);
};

// 订单利润报表导出
export const getProfitStatementList = (params) => {
    return api.get(`/api/tiktok/finance`, params);
};

//数量单位新增接口
export const newDesignUnit = (params) => {
    return api.post(`/api/design/unit`, params);
};

export const updateDesignUnit = (params) => {
    return api.put(`/api/design/unit/id/${params.id}`, params.data);
};

// 生成财务Excel报表
export const orderProfitStatementReport = (params) => {
    return api.post(`/api/stats/order/profits/report/create`, params);
};

//导出采购成本为0的财务基础数据
export const postStatsOrderProfitsExport = (params) => {
    return api.post(`/api/stats/order/profits/export`, params);
};




